import { DbRef, FulfillmentIntegrationNurseID, fulfillmentIntegrationNurseIDToName } from '@caresend/types';
import { getPath } from './path.js';
import { isInEnum } from '../typeValidation/enum.js';

/**
 * ```
 * `${DbRef.SHIFTS}/${id}/${childPath}`
 * ```
 */

function getShiftPath(id, childPath) {
  return getPath(`${DbRef.SHIFTS}/${id}`, childPath);
}
/**
 * ```
 * `${DbRef.SHIFTS}/${shiftID}/nursesOffered/${nurseID}/${childPath}`
 * ```
 */

function getShiftNurseOfferPath(shiftID, nurseID, childPath) {
  return getPath(getShiftPath(shiftID, `nursesOffered/${nurseID}`), childPath);
}
/**
 * Checks if a nurse ID represents an integration nurse and returns the integration name.
 * @param nurseID - The nurse ID to check
 * @returns The integration name if the nurse is an integration nurse, undefined otherwise
 */

const getNurseIntegrationName = nurseID => {
  const isNurseIntegration = isInEnum(nurseID, FulfillmentIntegrationNurseID);
  if (!isNurseIntegration) return undefined;
  return fulfillmentIntegrationNurseIDToName[nurseID];
};

export { getNurseIntegrationName, getShiftNurseOfferPath, getShiftPath };
